import { useQuery, useQueryClient } from "@tanstack/react-query";

import { CompanyForm } from "@/components/settings/CompanyForm";
import { Card, PageHeader, Spinner } from "@/components/ui/card";
import { api, unwrap } from "@/lib/api";
import { useT } from "@/lib/i18n";

/** Firma ma'lumoti (nom, telefon, manzil, logo): QR stikerda va ochiq sahifada ko'rinadi. Har firma admini o'zinikini o'zgartiradi. */
export function CompanyPage() {
  const { t } = useT();
  const qc = useQueryClient();
  const company = useQuery({
    queryKey: ["settings", "company"],
    queryFn: async () => unwrap(await api.GET("/api/settings/company/")),
  });
  if (company.isLoading) return <Spinner className="mx-auto my-10 size-8" />;
  const c = company.data && "id" in company.data ? company.data : null;
  const refresh = () => void qc.invalidateQueries({ queryKey: ["settings", "company"] });
  return (
    <>
      <PageHeader title={t("nav.company")} />
      <Card className="max-w-xl">
        <p className="mb-3 text-sm text-muted-foreground">{t("company.hint")}</p>
        <CompanyForm
          key={c?.id ?? "new"}
          company={c}
          saveLabel={t("common.save")}
          onSave={async (v) => {
            unwrap(await api.PATCH("/api/settings/company/", { body: v }));
            refresh();
          }}
          onUpload={async (file) => {
            const form = new FormData();
            form.append("file", file);
            unwrap(
              await api.POST("/api/settings/company/logo/", {
                body: form as never,
                bodySerializer: (b: unknown) => b as FormData,
              }),
            );
            refresh();
          }}
          onRemoveLogo={async () => {
            unwrap(await api.DELETE("/api/settings/company/logo/"));
            refresh();
          }}
        />
      </Card>
    </>
  );
}
